import NewUsersParamsServer from '../../server/newUsersParams';
import { addLoading, removeLoading } from './loading';

export const getNewUsersParams = () => async () => {
  return NewUsersParamsServer.getNewUsersParams();
};

export const updateNewUsersParams = params => async (dispatch) => {
  dispatch(addLoading());
  try {
    await NewUsersParamsServer.updateNewUsersParams(params);
  } finally {
    dispatch(removeLoading());
  }
};
